import React from 'react';

export default function useToggleState(initialValue = false) {
  const [state, setState] = React.useState(initialValue);
  const toggle = React.useCallback(() => setState((s) => !s), []);
  const close = React.useCallback(() => setState(false), []);
  const open = React.useCallback(() => setState(true), []);
  return [state, { toggle, close, open, set: setState }] as const;
}
